import { Checkbox, createTheme, type MantineColorsTuple, type MantineThemeOverride } from '@mantine/core';

/**
 * Fatoorati teal — shade 6 is the brand colour #0E7C74 (white text contrast ≈ 5.1:1, WCAG AA).
 * The same shade is used on printed documents (api/src/kernel/brand.ts BRAND_COLOR).
 */
export const brandTeal: MantineColorsTuple = [
  '#e7f6f4',
  '#cdebe7',
  '#9dd6cf',
  '#69c0b6',
  '#3fada1',
  '#23a093',
  '#0E7C74',
  '#0b6b64',
  '#085a54',
  '#054843',
];

/** Deep indigo accent of the logo (second tone of the invoice glyph). */
export const brandIndigo: MantineColorsTuple = [
  '#eef0fb',
  '#dadff4',
  '#b2bbe8',
  '#8794dc',
  '#6473d2',
  '#4e5ecc',
  '#3949AB',
  '#2f3d93',
  '#26327a',
  '#1c2661',
];

export const BRAND_COLOR = '#0E7C74';
export const BRAND_ACCENT = '#3949AB';

/** The application has one web shell (admin). */
export type ShellKind = 'admin';

const FONT_AR = 'Cairo, Tajawal, "Segoe UI", system-ui, -apple-system, sans-serif';
const FONT_EN = 'Tajawal, Cairo, "Segoe UI", system-ui, -apple-system, sans-serif';

/** Builds the Mantine theme. Arabic uses Cairo, English uses Tajawal (both ship Latin + Arabic glyphs). */
export function createKfmsTheme({ lang }: { lang: string; shell?: ShellKind }): MantineThemeOverride {
  const fontFamily = lang === 'ar' ? FONT_AR : FONT_EN;
  return createTheme({
    primaryColor: 'brand',
    primaryShade: 6,
    colors: { brand: brandTeal, accent: brandIndigo },
    fontFamily,
    fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    headings: { fontFamily, fontWeight: '700' },
    defaultRadius: 'md',
    cursorType: 'pointer',
    focusRing: 'auto',
    autoContrast: true,
    components: {
      Checkbox: Checkbox.extend({ defaultProps: { radius: 'sm' } }),
    },
  });
}
